import { http } from './http';

export async function getStockReport(params) {
    try {
        return await http.get('wms/reports/stock/', { params });
    } catch (e) {
        if (e.status === 404) return { data: mockStockReport };
        throw e;
    }
}

export async function getMovementReport(params) {
    try {
        return await http.get('wms/reports/movement/', { params });
    } catch (e) {
        if (e.status === 404) return { data: mockMovements };
        throw e;
    }
}

export async function getStatements() {
    try {
        return await http.get('wms/reports/statements/');
    } catch (e) {
        return { data: [] };
    }
}
